import { CognitoUserPool } from "amazon-cognito-identity-js";

const poolData = {
    UserPoolId: "us-east-2_a9MXk6aSP",
    ClientId: "412jc7palag8g9bpatkanhitc",
};

const userPool = new CognitoUserPool(poolData);

export default userPool;
